import { Modal, SubmitButton } from "@xola/ui-kit";
import { FormField, SecondaryButton } from "common";
import pluralize from "pluralize";
import React from "react";
import { number, object } from "yup";
import { XolaFormik } from "@/components/Common/XolaFormik";
import { CurrencyInputField } from "@/components/Field/CurrencyInputField";

interface SetVariantPricesModalProps {
    isOpen: boolean;
    selectedCount: number;
    onClose: () => void;
    onApply: (price: number) => Promise<void> | void;
}

const validationSchema = object({
    price: number().min(0, "Price must be positive").required("Price is required"),
});

export const SetVariantPricesModal = ({ isOpen, selectedCount, onClose, onApply }: SetVariantPricesModalProps) => {
    const handleSubmit = async (values: { price: number | null }) => {
        if (values.price === null) {
            return;
        }

        await onApply(values.price);
        onClose();
    };

    return (
        <Modal size="small" isOpen={isOpen} onClose={onClose}>
            <XolaFormik
                initialValues={{ price: null as number | null }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ handleSubmit, isSubmitting, values }) => (
                    <>
                        <Modal.Header>Set Variant Prices</Modal.Header>

                        <Modal.Body>
                            <div className="mb-4 rounded bg-blue-lighter p-3 text-sm">
                                Set the price for{" "}
                                <strong>
                                    <var data-var="selected-count">{selectedCount}</var> selected
                                </strong>{" "}
                                <var data-var="variant-label">{pluralize("variant", selectedCount)}</var>.
                            </div>

                            <FormField name="price" label="Price">
                                <CurrencyInputField isRequired autoFocus filterZero allowNegative={false} />
                            </FormField>
                        </Modal.Body>

                        <Modal.Footer>
                            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                            <SubmitButton
                                type="submit"
                                isLoading={isSubmitting}
                                disabled={values.price === null}
                                onClick={handleSubmit}
                            >
                                Apply
                            </SubmitButton>
                        </Modal.Footer>
                    </>
                )}
            </XolaFormik>
        </Modal>
    );
};
